<template>
  <div>
    <Header />
    <div class="main main-container">
      <div ref="left" class="left">
        <div class="userinfo">
          <div class="user-info">
            <img class="avatar" :src="user.avatar" />
            <div class="name-wrap">
              <div class="name">
                <span>{{ user.nickname }}</span>
                <template v-if="$store.getters.showVip">
                  <template
                    v-if="
                      $store.state.commonSetting.switch_state == 1 &&
                      user.vip_info &&
                      user.vip_info.icon_url &&
                      !getIsExpire(user.vip_info.end_at)
                    "
                  >
                    <img
                      :src="user.vip_info.icon_url"
                      class="vip-logo"
                      @click.stop="$router.push({ name: 'Vip' })"
                    />
                  </template>
                  <template v-else>
                    <img
                      :src="iconUrl"
                      class="vip-logo"
                      @click.stop="$router.push({ name: 'Vip' })"
                    />
                  </template>
                </template>
              </div>
              <div class="greeting">
                <span>Hi，</span>
                <span v-if="new Date().getHours() < 12">上午</span>
                <span v-else>下午</span>
                <span>好 ~</span>
              </div>
            </div>
          </div>
        </div>
        <el-menu class="menu-wrap" mode="vertical" unique-opened :default-active="activeMenuRoute">
          <template v-for="menu in menus">
            <el-submenu
              v-if="!menu.hide && menu.children && menu.children.length"
              :key="`submenu-${menu.route}`"
              :index="menu.route"
            >
              <template #title>
                <img :src="menu.icon" class="menu-icon" />
                <span>{{ menu.title }}</span>
                <span v-if="menu.showRedDot" class="redDot"></span>
              </template>
              <template v-for="submenu in menu.children">
                <el-menu-item
                  v-if="!submenu.hide"
                  :key="submenu.route"
                  :index="submenu.route"
                  @click="onClickMenuItem(submenu)"
                >
                  <span>{{ submenu.title }}</span>
                  <MemberMenuCount :type="submenu.countType"></MemberMenuCount>
                </el-menu-item>
              </template>
            </el-submenu>
            <el-menu-item
              v-else-if="!menu.hide"
              :key="`item-${menu.route}`"
              :index="menu.route"
              @click="onClickMenuItem(menu)"
            >
              <img
                :src="$route.name == menu.route ? menu.iconActive : menu.icon"
                class="menu-icon"
              />
              <span>{{ menu.title }}</span>
              <MemberMenuCount :type="menu.countType"></MemberMenuCount>
            </el-menu-item>
          </template>
        </el-menu>
      </div>
      <LoadContainer
        :isLoaded.sync="isLoaded"
        class="right"
        :class="{
          'right-flex':
            $route.name == 'MemberHomeworkIndex' ||
            $route.name == 'MemberEvaluation' ||
            $route.name == 'MemberClockin',
        }"
      >
        <template v-if="!$route.meta.hideBreadcrumb">
          <div class="member-bread" v-if="breads.length">
            <span v-for="(bread, index) in breads" :key="index">
              <router-link
                v-if="bread.name"
                :to="{
                  name: bread.name,
                  query: bread.query,
                  params: bread.params,
                }"
              >
                {{ bread.title }}
              </router-link>
              <span
                v-else
                :class="{
                  current: index == breads.length - 1,
                  query: bread.query,
                  params: bread.params,
                }"
              >
                {{ bread.title }}
              </span>
              <span class="slash" v-if="index < breads.length - 1">/</span>
            </span>
          </div>
          <div class="member-bread" v-else-if="$route.meta.bread">
            <span v-for="(bread, index) in $route.meta.bread" :key="index">
              <router-link v-if="bread.route" :to="bread.route">
                {{ bread.title }}
              </router-link>
              <span v-else :class="{ current: index == $route.meta.bread.length - 1 }">
                {{ bread.title }}
              </span>
              <span class="slash" v-if="index < $route.meta.bread.length - 1"> / </span>
            </span>
          </div>
        </template>
        <div class="content">
          <router-view></router-view>
        </div>
      </LoadContainer>
    </div>
    <Footer :fixed="fixedFooter"></Footer>
    <div v-if="fixedFooter" class="member-footer-placeholder"></div>
  </div>
</template>
<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import LoadContainer from '@/components/LoadContainer.vue';
import MemberMenuCount from './components/MemberMenuCount.vue';

export default {
  name: 'Member',
  components: {
    Header,
    Footer,
    LoadContainer,
    MemberMenuCount,
  },
  data() {
    return {
      fixedFooter: false,
      isLoaded: false,
      activeMenuRoute: this.$route.name,
    };
  },
  created() {
    this.$store.commit('setBreads', this.$route);
    this.$store.dispatch('refreshMessageState');
    this.$store.dispatch('refreshHomeworkState');
    this.$store.dispatch('get_user_info');
    this.initFooter();
  },
  computed: {
    iconUrl() {
      return this.$store.state.commonSetting.not_vip_icon;
    },
    user() {
      return this.$store.state.user_info;
    },
    breads() {
      const data = this.$store.state.breads || [];
      if (data.length > 1) {
        data.forEach((item) => {
          if (item.name == 'MemberPeriods' && item.query && item.query.tab == 'periods') {
            item.title = '我的约排课';
            item.query.tab = 'otn';
          }
        });
      }
      return data;
    },
    commonSetting() {
      return this.$store.state.commonSetting;
    },
    is_desktop() {
      return !!this.$store.state.desktop;
    },
    showRedDot() {
      return (
        this.$store.state.homeworkState.count ||
        this.$store.state.homeworkState.wait_correction_count
      );
    },
    menus() {
      const result = [
        {
          route: 'MemberCalendar',
          icon: require('@/assets/images/member/icon-calendar.png'),
          iconActive: require('@/assets/images/member/icon-calendar-active.png'),
          title: '学习日历',
        },
        {
          route: 'SubmenuCourse',
          icon: require('@/assets/images/member/icon-course.png'),
          iconActive: require('@/assets/images/member/icon-course-active.png'),
          title: '学习中心',
          children: [
            {
              route: 'MemberStudy',
              title: '我的课程',
            },
            {
              route: 'MemberStudyTask',
              title: '我的任务',
              hide: location.hostname.includes('gzmstt'),
            },
            // {
            //   route: 'MemberClasses',
            //   title: '我的班级',
            //   hide: this.is_desktop || this.commonSetting.switch_class_module != 1,
            // },
            // {
            //   route: 'MemberOto',
            //   title: '我的约课',
            //   hide: this.is_desktop || this.commonSetting.switch_oto_module != 1,
            // },
            {
              route: 'MemberPeriods',
              query: { tab: 'otn' },
              title: '我的约排课',
              hide: this.is_desktop || this.commonSetting.switch_contract_schedule != 1,
            },
          ],
        },
        {
          route: 'SubmenuPractise',
          icon: require('@/assets/images/member/icon-practise.png'),
          iconActive: require('@/assets/images/member/icon-practise-active.png'),
          title: '练习中心',
          showRedDot: this.showRedDot,
          // hide: this.is_desktop,
          children: [
            // {
            //   route: "MemberEvaluation",
            //   title: "我的测评",
            //   hide:
            //     this.is_desktop ||
            //     this.commonSetting.switch_question_module != 1,
            // },
            {
              route: 'MemberHomeworkIndex',
              title: '我的作业',
              countType: 'homework',
              hide: this.commonSetting.class_homework_module != 1,
            },
            {
              route: 'MemberTest',
              title: '我的考试',
              countType: 'test',
              hide: this.is_desktop || this.commonSetting.switch_question_module != 1,
            },
          ],
        },
        {
          route: 'SubmenuWealth',
          icon: require('@/assets/images/member/icon-wealth.png'),
          iconActive: require('@/assets/images/member/icon-wealth-active.png'),
          title: '资产中心',
          hide: this.is_desktop,
          children: [
            {
              route: 'MemberWealth',
              title: '我的财富',
              hide:
                this.commonSetting.switch_coupon_module != 1 &&
                this.commonSetting.switch_study_module != 1,
            },
            {
              route: 'MemberIntegral',
              title: '我的' + this.commonSetting.point_info.point_name,
              hide: this.commonSetting.switch_integral_module != 1,
            },
            {
              route: 'MemberClockin',
              title: '我的打卡',
              hide: this.commonSetting.switch_take_module != 1,
            },
          ],
        },
        {
          route: 'SubmenuOrder',
          icon: require('@/assets/images/member/icon-order.png'),
          iconActive: require('@/assets/images/member/icon-order-active.png'),
          title: '订单中心',
          hide: this.is_desktop,
          children: [
            {
              route: 'MemberOrder',
              title: '我的订单',
            },
            {
              route: 'MemberAddress',
              title: '收货地址',
            },
          ],
        },
        {
          route: 'MemberMessage',
          icon: require('@/assets/images/member/icon-message.png'),
          iconActive: require('@/assets/images/member/icon-message-active.png'),
          title: '消息中心',
          countType: 'message',
          hide: this.is_desktop,
        },
        {
          route: 'MemberProfile',
          icon: require('@/assets/images/member/icon-person.png'),
          iconActive: require('@/assets/images/member/icon-person-active.png'),
          title: '个人设置',
        },
      ];
      return result;
    },
  },
  watch: {
    $route() {
      this.$store.commit('setBreads', this.$route);
      this.activeMenuRoute = this.$route.name;
    },
    commonSetting() {
      this.initFooter();
    },
  },
  methods: {
    onClickMenuItem(menu) {
      this.$router.push({
        name: menu.route,
        query: menu.query,
      });
    },
    onMenuClick() {
      this.isLoaded = false;
    },
    getBreads(data) {
      const breads = data.split('/');
      return breads;
    },
    //判断会员是否过期
    getIsExpire(time) {
      if (time) {
        const now = this.$actionTool.getCurTimestamp(); //当前时间的时间戳
        if (now > time) {
          //如果当前时间大于会员到期时间，说明已过期
          return true;
        }
      }
      return false;
    },
    initFooter() {
      this.$nextTick(() => {
        // todo if (document.body.clientHeight < document.documentElement.clientHeight - 178) {
        if (document.body.clientHeight < document.documentElement.clientHeight) {
          this.fixedFooter = true;
        } else {
          this.fixedFooter = false;
        }

        let height = this.$refs.left.clientHeight;
        this.$store.commit('setMemberLeftHeight', height);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.main {
  min-height: 300px;
  padding-top: 94px;
  // overflow: hidden;
  margin-bottom: 30px;
  display: flex;
  justify-content: space-between;
}

.left {
  background-color: white;
  align-items: stretch;
  width: 228px;
  //padding: 24px 0;
  box-sizing: border-box;
  border-radius: 8px;
  overflow: hidden;
}

.userinfo {
  padding: 24px;
  background-color: white;
}

.right {
  width: 956px;
  position: relative;
  box-sizing: border-box;
}
.right {
  .content {
    height: calc(100% - 56px);
  }
}
.right-flex {
  display: flex;
  flex-direction: column;

  .content {
    flex: 1;
  }
}

.user-info {
  display: flex;
  align-items: center;
  .avatar {
    width: 48px;
    height: 48px;
    border-radius: 100%;
    margin-right: 12px;
  }

  .name-wrap {
    width: 120px;
    white-space: nowrap;
  }

  .name {
    font-size: 16px;
    color: #333;
    font-weight: 600;
    margin-bottom: 5px;
    overflow: hidden;
    text-overflow: ellipsis;
    span {
      display: inline-block;
      max-width: 90px;
      overflow: hidden;
      text-overflow: ellipsis;
      vertical-align: middle;
    }
    .vip-logo {
      width: 18px;
      height: 18px;
      vertical-align: middle;
      margin-left: 3px;
      cursor: pointer;
    }
  }

  .greeting {
    font-size: 14px;
    color: rgba(184, 184, 184, 1);
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.vip {
  padding-top: 43px;
  font-size: 14px;

  .buy {
    margin-top: 4px;
    display: inline-block;
    text-decoration: underline;
  }

  span {
    color: #8c8c8c;
  }

  a {
    color: $primary-color;
  }
}

.menu-wrap {
  // padding: 0 0 24px 0;
  border-right: none;
  .el-submenu .el-menu-item {
    padding-left: 60px !important;
    color: #7d7f85;
  }
  ::v-deep.el-submenu__icon-arrow {
    font-size: 14px;
    font-weight: bold;
    color: #999;
  }
  ::v-deep .el-submenu__title,
  .el-menu-item {
    height: 48px;
    line-height: 48px;
    padding-left: 24px !important;
    padding-right: 24px;
    font-size: 14px;
    color: #333;
    &:hover {
      color: #000;
      background-color: #f4f4f4;
    }
    &.is-active {
      font-weight: 600;
      color: $primary-color;
      background-color: $primary-color-04;
    }
  }
  .menu-icon {
    width: 18px;
    height: 18px;
    margin-right: 16px;
  }
  .redDot {
    width: 6px;
    height: 6px;
    display: inline-block;
    background: red;
    border-radius: 50%;
    margin: 0 0 12px 2px;
  }
}

.member-bread {
  background-color: white;
  height: 48px;
  line-height: 48px;
  font-size: 16px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.45);
  border-radius: 4px 4px 0 0;
  margin-bottom: 8px;
  padding: 0 24px;
  border-radius: 8px;
  a {
    color: rgba(0, 0, 0, 1);
  }

  .current {
    color: #595959;
  }

  .slash {
    margin: 0 8px;
  }
}

.red-point {
  height: 18px;
  display: inline-block;
  background-color: #ff2b4e;
  border-radius: 9px;
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 18px;
  text-align: center;
  margin-top: 2px;
  margin-right: 10px;
  text-align: center;

  &.small {
    width: 18px;
  }

  &.middle {
    width: 28px;
  }

  &.big {
    width: 34px;
  }
}
.member-footer-placeholder {
  height: 148px;
}
</style>
